import './main-layout.styles.css';

import * as React from 'react';
import Box from '@mui/material/Box';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from '../header/header.component';
import { MainLayoutBox } from './main-layout.styled';

import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";

export const menus = [
    {
        title: "Főoldal",
        url: '/',
        icon: <ScatterPlotIcon/>
    },
    {
        title: "Posztok",
        url: '/posztok',
        icon: <ScatterPlotIcon/>
    },
    {
        title: "Üzenetek",
        url: '/uzenetek',
        icon: <ScatterPlotIcon/>
    },
    {
        title: "Hírlevél",
        url: '/hirlevel',
        icon: <ScatterPlotIcon/>
    },
    {
        title: "Események",
        url: '/esemenyek',
        icon: <ScatterPlotIcon/>
    },
    {
        title: "Beállítások",
        url: '/beallitasok',
        icon: <ScatterPlotIcon/>
    },
    {
        title: "Kijelentkezés",
        url: '/kijelentkezes',
        icon: <LogoutTwoToneIcon/>
    }
]

export default function MainLayout() {
    return (
        <MainLayoutBox>
            <Header menus={menus}/>

            <Box component='main' sx={{overflow: "scroll", height: "100vh"}} className='main'>
                <Outlet/>
            </Box>
        </MainLayoutBox>
    );
}